module.exports = __webpack_public_path__ + "img/gywm.9abe448a.png";